import React, {  useContext } from 'react';
import {Row, Col, Modal, ModalDialog, Button} from 'react-bootstrap'
import Select from 'react-select';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { GlobalContext } from "../../handlers/GlobalContext";

//TODO: Delete below
// const countries = [
//     { value: 3, label: 'Bosnia & Herzegovina' },
//     { value: 2, label: 'Croatia' },
//     { value: 5, label: 'Montenegro' },
//     { value: 6, label: 'North Macedonia' },
//     { value: 7, label: 'Other' },
//     { value: 4, label: 'Serbia' },
//     { value: 1, label: 'Slovenia' }
// ];
//
// const languages = [
//     { value: 2, label: 'Bosnian' },
//     { value: 3, label: 'Croatian' },
//     { value: 1, label: 'English' },
//     { value: 4, label: 'Montenegrin' },
//     { value: 5, label: 'Macedonian' },
//     { value: 6, label: 'Serbian' },
//     { value: 7, label: 'Slovenian' },
// ]

const fieldMapping = {
    firstname: "Name",
    lastname: "Surname",
    email: "Email",
    username: "UserName",
    country: "Country",
    language: "DefaultLanguage"
}

class AccountSettings extends React.Component {
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.setEditMode = this.setEditMode.bind(this);
        this.hasChanges = this.hasChanges.bind(this);
        this.setFieldValues = this.setFieldValues.bind(this);
        this.translate = this.translate.bind(this);
        //this.revertChanges = this.revertChanges.bind(this);
        //this.resetSelection = props.reset;

        this.state = {
            country: {value: -1},
            language: {value: -1},
            edit: 0,
            passwordResetPending: false
        }
    }

    componentWillMount(){
        this.countries = this.context[0].locale.countries.map((c) => { return { value: c.countryId, label: this.translate(c.element)} });
        this.languages = this.context[0].locale.languages.map((l) => { return { value: l.languageId, label: this.translate(l.element)} });

        if(!!this.context[0].auth && !!this.context[0].auth.account){
            this.state.accountData = {
                id: this.context[0].auth.account.userId,
                email: this.context[0].auth.account.email,
                username: this.context[0].auth.account.userName,
                firstname: this.context[0].auth.account.firstname,
                lastname: this.context[0].auth.account.lastname,
                country: { value: this.context[0].auth.account.country.countryId, label: this.context[0].auth.account.country.longName },
                language: { value: this.context[0].auth.account.language.languageId, label: this.context[0].auth.account.language.longName }}

            this.state.country = this.countries.filter((c) => { return c.value == this.state.accountData.country.value })[0];
            this.state.language = this.languages.filter((c) => { return c.value == this.state.accountData.language.value })[0];
            this.state.preloadedCountry = Object.assign({}, this.state.country);
            this.state.preloadedLanguage = Object.assign({}, this.state.language);
            this.state.passwordResetPending = this.context[0].auth.account.passwordResetPending;

        }
    }

    setEditMode(mode){
        if([0,1,2].indexOf(mode) < 0) return;
        this.setState({edit: mode});
    }
    setFieldValues(values){
        this.state.formData = values;
    }
    hasChanges(resetForm){
        resetForm();
        this.componentWillMount();
        return true;
    }

    handlePasswordSubmit( values, actions) {
        let fPayload = {
            //"CurrentPassword": values.password_current,
            "NewPassword": values.password
        }
        if(!this.state.passwordResetPending) {
            fPayload.CurrentPassword = values.password_current;
        }

        let dispatch = this.context[1];
        dispatch({ type: 'UPDATE_USER_PASSWORD', payload: fPayload })
            .then(() => {
                let updateErrorMessage = !!this.context[0].error ? this.context[0].error.data : undefined;
                if(!!updateErrorMessage) {
                    //actions.resetForm({ password: '', password_current: '', password_repeat: '' });

                    actions.setFieldError('pmessage', this.translate(updateErrorMessage) );
                    //actions.setFieldTouched('pmessage', true, true);
                    actions.setFieldValue('password', '', false);
                    //actions.setFieldTouched('password', false);
                    if(!this.state.passwordResetPending) actions.setFieldValue('password_current', '', false);
                    //actions.setFieldTouched('password_current', false);
                    actions.setFieldValue('password_repeat', '', false);
                    //actions.setFieldTouched('password_repeat', false);
                    actions.setSubmitting(false);
                } else {
                    if(!!this.context[0].message) {
                        alert(this.translate(this.context[0].message));
                    }
                    //this.setState({passwordResetPending: this.context[0].auth.account.passwordResetPending});
                    this.componentWillMount();
                    actions.setSubmitting(false);
                    this.setEditMode(0);
                }
            });
    }

    handleSubmit( values, actions ){
        let fPayload = {}
        for (const [key, value] of Object.entries(values)) {
            if( ((typeof value !== 'object') && (value !== this.state.accountData[key])) || ((typeof value === 'object') && (value.value !== this.state.accountData[key].value)) ) {
                if(!!fieldMapping[key]) {
                    fPayload[fieldMapping[key]] = value;
                }
            }
        }

        let dispatch = this.context[1];
        dispatch({ type: 'UPDATE_USER', payload: fPayload })
            .then(() => {
                let updateErrorMessage = !!this.context[0].error ? this.context[0].error.data : undefined;
                if(!!updateErrorMessage) {
                    actions.setFieldError('message', this.translate(updateErrorMessage));
                    actions.setSubmitting(false);
                } else {
                    if(!!this.context[0].message) {
                        alert(this.translate(this.context[0].message));
                    }
                    actions.setSubmitting(false);
                    this.componentWillMount();
                    this.setEditMode(0);
                }
            });
    }

    handleChange = ( field, values ) => {
        let sField = {};
        sField[field] = values;
        this.setState(sField);
    }

    translate = (term, alt) => {
        return this.context[0].locale.translation[term] || alt || term;
    }

    render(){
        return(

            <div className="blog-item-details text-center col">
                { this.state.edit == 0 || this.state.edit == 1 ?
                <div className={"blog-content"}>
                <h3 className={"blog-title account-title"}>{ this.translate("account-basic-title","Basic information")}</h3>
                    <div className={"blog-product extended"}>
                        <Formik
                            initialValues={{ email: this.state.accountData.email, username: this.state.accountData.username,
                                firstname: this.state.accountData.firstname, lastname: this.state.accountData.lastname,
                                country: this.state.accountData.country, language: this.state.accountData.language, message: '',
                                field_country: this.state.accountData.country.label, field_language: this.state.accountData.language.label
                            }}
                            validate={values => {
                                const errors = {};
                                if (!values.username) {
                                    errors.username = this.translate('register-error-usernameRequired','Username required!');
                                }
                                if ( !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email) ) {
                                    errors.email = this.translate('register-error-invalidEmail','Invalid email address');
                                }
                                if (!values.firstname) {
                                    errors.firstname = this.translate('register-error-firstNameRequired','First name is required!');
                                }
                                if (!values.lastname) {
                                    errors.lastname = this.translate('register-error-lastNameRequired','Last name is required!');
                                }

                                values.country = this.state.country;
                                //values.field_country = this.state.country.label;
                                if (values.country.value == -1) {
                                    errors.country = this.translate('register-error-emptyCountry','Please select a country!');
                                }
                                values.language = this.state.language;
                                //values.field_language = this.state.language.label;
                                if (values.language.value == -1) {
                                    errors.language = this.translate('register-error-emptyLanguage','Please select a default language!');
                                }
                                // if (!!values.message){
                                //     errors.message = values.message;
                                // }
                                // else if (
                                //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                                // ) {
                                //     errors.email = 'Invalid email address';
                                // }
                                return errors;
                            }}
                            onSubmit= { this.handleSubmit }
                        >
                            {({ values,
                                isSubmitting,
                                 resetForm
                            }) => (
                                <Form className="login-form">
                                    <ErrorMessage name="message" component="div" className="error-field" />
                                    <Row className={"product-info-row row"}>
                                        <Col lg={3} className={"product-info-label text-left"}>
                                            <span> { this.translate("register-placeholder-username","Username")} </span>
                                            <ErrorMessage name="username" component="div" className="error-field" />
                                        </Col>
                                        <Col lg={9}>
                                            <Field type="text" name="username" className="formField" placeholder={ this.translate("register-placeholder-username","Username")} disabled={true} />

                                        </Col>
                                    </Row>
                                    <Row className={"product-info-row row"}>
                                        <Col lg={3} className={"product-info-label text-left"}>
                                            <span>{ this.translate("register-placeholder-email","E-mail")}</span>
                                            <ErrorMessage name="email" component="div" className="error-field"/>
                                        </Col>
                                        <Col lg={9}>
                                            <Field type="email" name="email" placeholder={ this.translate("register-placeholder-email","E-mail")} disabled={this.state.edit == 0}/>
                                        </Col>
                                    </Row>
                                    <Row className={"product-info-row row"}>
                                        <Col lg={3} className={"product-info-label text-left"}>
                                            <span>{ this.translate("register-placeholder-firstName","First name")}</span>
                                            <ErrorMessage name="firstname" component="div" className="error-field" />
                                        </Col>
                                        <Col lg={9}>
                                            <Field type="text" name="firstname" className="formField" placeholder={ this.translate("register-placeholder-firstName","First name")} disabled={this.state.edit == 0} />
                                        </Col>
                                    </Row>
                                    <Row className={"product-info-row row"}>
                                        <Col lg={3} className={"product-info-label text-left"}>
                                            <span>{ this.translate("register-placeholder-lastName","Last name")}</span>
                                            <ErrorMessage name="lastname" component="div" className="error-field" />
                                        </Col>
                                        <Col lg={9}>
                                            <Field type="text" name="lastname" className="formField" placeholder={ this.translate("register-placeholder-lastName","Last name")} disabled={this.state.edit == 0} />
                                        </Col>
                                    </Row>
                                    <Row className={"product-info-row row"}>
                                        <Col lg={3} className={"product-info-label text-left"}>
                                            <span>{ this.translate("register-placeholder-country","Country")}</span>
                                            <ErrorMessage name="country" component="div" className="error-field" />
                                        </Col>
                                        <Col lg={9}>
                                            { this.state.edit == 0 ? <Field type="text" name="field_country" value={this.state.preloadedCountry.label} className="formField" placeholder="" disabled={true} /> : null }
                                            { this.state.edit != 0 ? <Select
                                                className={"input-select"}
                                                name="country"
                                                options={this.countries}
                                                multi={false}
                                                onChange={this.handleChange.bind(this,"country")}
                                                value={this.state.country}
                                                placeholder={ this.translate("register-placeholder-country","Country")}

                                            /> : null }
                                        </Col>
                                    </Row>
                                    <Row className={"product-info-row row"}>
                                        <Col lg={3} className={"product-info-label text-left"}>
                                            <span>{ this.translate("register-placeholder-language","Language")}</span>
                                            <ErrorMessage name="language" component="div" className="error-field" />
                                        </Col>
                                        <Col lg={9}>
                                            { this.state.edit == 0 ? <Field type="text" name="field_language" value={this.state.preloadedLanguage.label}  className="formField" placeholder="" disabled={true} /> : null }
                                            { this.state.edit != 0 ? <Select
                                                className={"input-select"}
                                                name="language"
                                                options={this.languages}
                                                multi={false}
                                                onChange={this.handleChange.bind(this,"language")}
                                                value={this.state.language}
                                                placeholder={ this.translate("register-placeholder-language","Default language")}
                                                disabled={this.state.edit == 0}
                                            /> : null }
                                        </Col>
                                    </Row>
                                    { !!this.state.edit && this.state.edit == 1 ? <button type="submit" disabled={isSubmitting}>
                                        { this.translate("register-button-submit", "Submit")}
                                    </button> : null }
                                    { !!this.state.edit && this.state.edit == 1 ? <button type="button" className={"secondary"} disabled={isSubmitting} onClick={() => {this.hasChanges(resetForm) && this.setEditMode(0)} }>
                                        { this.translate("register-button-back", "Back")}
                                    </button> : null }
                                    { this.state.edit == 0 ? <button type="button" className={"secondary"} disabled={isSubmitting} onClick={() => { this.setEditMode(1)} }>
                                        { this.translate("account-button-edit", "Edit information")}
                                    </button> : null }
                                    { this.state.edit == 0 ? <button type="button" className={"secondary"} disabled={isSubmitting} onClick={() => {this.setEditMode(2)} }>
                                        { this.translate("account-button-changePassword", "Change password")}
                                    </button> : null }
                                    { this.setFieldValues(values) }
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div> : null }



                { this.state.edit == 2 ?
                <div className={"blog-content"}>
                    <h3 className={"blog-title account-title"}>{ this.translate("account-security-title","Account security")}</h3>
                    <div className={"blog-product"}>
                        <Formik
                            initialValues={{ password_current: '', password: '', password_repeat: '', pmessage: '' }}
                            validate={values => {
                                const errors = {};
                                if (!this.state.passwordResetPending && !values.password_current) {
                                    errors.password_current = this.translate('register-error-emptyPassword','Password cannot be empty!');
                                }
                                if (!this.state.passwordResetPending && (!!values.password_current && values.password_current.length < 6 || values.password_current.toLowerCase() === values.password_current || !/\d/.test(values.password_current)) ) {
                                    errors.password_current = this.translate('register-error-simplePassword','Password cannot be less than 6 characters and should contain at least one number and one capital letter!');
                                }
                                if (!values.password) {
                                    errors.password = this.translate('register-error-emptyPassword','Password cannot be empty!');
                                }
                                if (!!values.password && values.password.length < 6 || values.password.toLowerCase() === values.password || !/\d/.test(values.password) ) {
                                    errors.password = this.translate('register-error-simplePassword','Password cannot be less than 6 characters and should contain at least one number and one capital letter!');
                                }
                                if (!!values.password && !!values.password_repeat && values.password !== values.password_repeat) {
                                    errors.password_repeat = this.translate('register-error-mismatchPassword','Repeated password does not match previously entered password!');
                                }
                                return errors;
                            }}
                            onSubmit= { this.handlePasswordSubmit }
                        >
                            {({ isSubmitting }) => (
                                <Form className="login-form">
                                    <ErrorMessage name="pmessage" component="div" className="error-field" />
                                    { !this.state.passwordResetPending ? <Row className={"product-info-row row"}>
                                        <Col lg={3} className={"product-info-label text-left"}>
                                            <span>{ this.translate("account-placeholder-passwordCurrent","Current password") }</span>
                                            <ErrorMessage name="password_current" component="div" className="error-field" />
                                        </Col>
                                        <Col lg={9}>
                                            <Field type="password" name="password_current" placeholder={this.translate("register-placeholder-password", "Password")} />
                                        </Col>
                                    </Row> : null }
                                    <Row className={"product-info-row row"}>
                                        <Col lg={3} className={"product-info-label text-left"}>
                                            <span>{ this.translate("account-placeholder-passwordNew","New password") }</span>
                                            <ErrorMessage name="password" component="div" className="error-field" />
                                        </Col>
                                        <Col lg={9}>
                                            <Field type="password" name="password" placeholder={this.translate("register-placeholder-password", "Password")} />
                                        </Col>
                                    </Row>
                                    <Row className={"product-info-row row"}>
                                        <Col lg={3} className={"product-info-label text-left"}>
                                            <span>{ this.translate("account-placeholder-passwordNewRepeat","Repeat new password") }</span>
                                            <ErrorMessage name="password_repeat" component="div" className="error-field" />
                                        </Col>
                                        <Col lg={9}>
                                            <Field type="password" name="password_repeat" placeholder={this.translate("register-placeholder-passwordRepeat", "Password (Repeat)")} />
                                        </Col>
                                    </Row>
                                    <button type="submit" disabled={isSubmitting}>
                                        { this.translate("register-button-submit", "Submit")}
                                    </button>
                                    <button type="button" className={"secondary"} disabled={isSubmitting} onClick={() => {this.setEditMode(0)} }>
                                        { this.translate("register-button-back", "Back")}
                                    </button>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div> : null }
            </div>
        );
    }
}

AccountSettings.contextType = GlobalContext;
export default AccountSettings;